import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";
import MaterialIcon from "src/shared/components/MaterialIcon";

type WithOnlyBackButtonProps = {
  children: React.ReactNode;
  className?: string;
};

export default function WithOnlyBackButton({ children, className }: WithOnlyBackButtonProps) {
  return (
    <div>
      <a
        data-name="with_only_back_button:material_icon"
        sx={{ ...backButtonStyle }}
        className={className}
        onClick={() => window.history.back()}
      >
        <MaterialIcon icon="arrow_back" />
      </a>
      {children}
    </div>
  );
}

const backButtonStyle: ThemeUIStyleObject = {
  display: "block",
  position: "absolute",
  top: "0",
  left: "0",
  paddingY: "dt_m",
  paddingX: "dt_s",
  fontSize: "24px",
  cursor: "pointer",
};
